<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true ? 'User Badges' : 'Deleted User Badges'
                "
              ></h3>
              <template v-if="isDeletePage() != true">
                <!-- <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/badges/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn> -->
              </template>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="4">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search badges..."
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                
                <!-- <v-col sm="2">
                  <v-btn
                    rounded
                    color="success"
                    :loading="isExcelloading"
                    @click="generateExcel"
                  >
                    <v-icon left>mdi-file-excel</v-icon>
                    Export
                  </v-btn>
                </v-col> -->
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="285"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>&nbsp; Sr. No.</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">Badge</th>
                      <th class="text-left">User Name</th>
                    </tr>
                  </thead>
                  <tbody v-if="badges.length != 0">
                    <tr
                      v-for="(badge, i) in badges"
                      :key="`badge_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': badges.length - 1 == i,
                      }"
                    >
                      <td>&nbsp;{{ i + 1 }}</td>
                      <td>
                        <v-tooltip bottom v-if="badge.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Badge is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="badge.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Badge is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>{{ badge.Badge ? badge.Badge.name : "" }}</td>
                      <td>{{ badge.user ? badge.user.name : "" }}</td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="9" class="text-center">No badges found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Success Dialog -->
      <v-dialog v-model="is_deleted_badge" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Success!</h1>
                      <br />
                      <h3>Badge deleted successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_deleted_badge = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "UserBadgesPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: null,
        category: null,
      },
      badges: [],
      statuses: [
        { text: "ACTIVE", value: "1" },
        { text: "INACTIVE", value: "0" },
      ],
      categories: [
        { text: "Activity", value: "activity" },
        { text: "Achievement", value: "achievement" },
        { text: "Social", value: "social" },
        { text: "Gaming", value: "gaming" },
        { text: "VIP", value: "vip" },
        { text: "Special", value: "special" },
      ],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      isLoading: false,
      isExcelloading: false,
      is_deleted_badge: false,
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword || "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&search_keyword=" +
        this.filter.search_keyword +
        "&is_active=" +
        (this.filter.is_active || "") +
        "&category=" +
        (this.filter.category || "");

      await axios
        .get(`user_badges?${query}`)
        .then((response) => {
          this.badges = response.data.data;
          console.log("badges", this.badges);
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
        });
      this.isLoading = false;
    },

    async generateExcel() {
      this.isExcelloading = true;
      let query =
        "search_keyword=" +
        this.filter.search_keyword +
        "&is_active=" +
        (this.filter.is_active || "") +
        "&category=" +
        (this.filter.category || "");
      let response = await axios.get(`badge_exports?${query}`);
      if (response) {
        window.open(`${response.data.data}`, "_blank");
      }
      this.isExcelloading = false;
    },

    async Delete_this(id) {
      await axios
        .post(`/badges/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.is_deleted_badge = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    async Restore_this(id) {
      await axios
        .post(`/badges/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
